import styles from './Text.css';


export function GYMcad() {
  return (
    <div class="body">



<div class="row" id="GalleryThree">
  <div class="column" >   
                      <h4>GYMcad, 2024-2026
            <br/>
               <br/>
Brand Identity System and Fundraising Data Visualization for the Minneapolis College of Art and Design &#40; MCAD &#41; Gym Facilities
               <br/><br/>
               Infographics, Posters, and Flyer.
                </h4>
                </div>
</div>
<div class="row">
<div class="column">       
        <img  src="GYMcad1.jpg"></img>
</div>
<div class="column">
        <img  src="GYMcad2.jpg"></img>
</div>
<div class="column">
        <img  src="GYMcad5.jpg"></img>  
</div>
<div class="column">
        <img  src="GYMcad3.jpg"></img>
  </div>
<div class="column">
        <img  src="GYMcad4.jpg"></img>
</div>
        </div>
        
        </div>
        

  );
}
